var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useOnboardingQueryParam } from 'root/src/client/v2/onboarding/hooks/useOnboardingQueryParam';
import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls';
import { useMutation } from '@tanstack/react-query';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { OnboardingPrimaryButton, OnboardingStep } from 'root/src/client/v2/onboarding/components/OnboardingStep';
export const DROP_ONBOARDING_INITIAL_STEPS = (drop) => {
    var _a;
    return [
        {
            stepInteraction: false,
            disableActions: true,
            position: 'bottom',
            selector: '.MuiLiveCountdown-liveCountdownContainer',
            resizeObservables: ['.MuiLiveCountdown-liveCountdownContainer'],
            content: () => {
                const router = useRouter();
                const pushRouteMutation = useMutation({
                    mutationFn: () => __awaiter(void 0, void 0, void 0, function* () {
                        yield router.push(routeUrls.drops({ onboarding: true }));
                    }),
                    mutationKey: ['push'],
                });
                useEffect(() => {
                    void pushRouteMutation.mutateAsync();
                }, []);
                const isLoading = pushRouteMutation.isPending;
                return (<OnboardingStep disableArrows={isLoading} disableDots={isLoading}>
					{isLoading && <LoadingCircles className="flex px-8 py-2 flex-initial" width={50} height={50}/>}
				</OnboardingStep>);
            },
        },
        {
            position: 'bottom',
            selector: '.MuiLiveCountdown-liveCountdownContainer',
            resizeObservables: ['.MuiLiveCountdown-liveCountdownContainer'],
            content: () => (<OnboardingStep>
				<div className="flex flex-col gap-2">
					<div className="text-black">
						<p className="text-black font-medium text-lg">Countdown</p>
						<p className="text-black opacity-60">See how much time is left to join the Drop and take part before it's over!</p>
					</div>
				</div>
			</OnboardingStep>),
        },
        ...(((_a = drop.initialProduct) === null || _a === void 0 ? void 0 : _a.length) ? [{
                selector: '.AvailableProgressBar',
                resizeObservables: ['.AvailableProgressBar'],
                content: (<OnboardingStep>
				<div className="text-black">
					<p className="text-black font-medium text-lg">Rewards for Your Community</p>
					<p className="text-black opacity-60">
						This shows how many keys remain for creators to join the Drop.
						No purchase needed - claim a dare, and we’ll email you the game key if it’s not free to play.
					</p>
				</div>
			</OnboardingStep>),
            }] : [{
                selector: '.MuiDaresSlider-infoItem',
                resizeObservables: ['.MuiDaresSlider-infoItem'],
                content: (<OnboardingStep>
				<div className="text-black">
					<p className="text-black font-medium text-lg">Rewards for Your Community</p>
					<p className="text-black opacity-60">View the reward pool for this game and earn your share. No purchase
						needed—claim a dare, and we’ll email you game keys if it’s not free to play.
					</p>
				</div>
			</OnboardingStep>),
            }]),
        {
            resizeObservables: [
                '.MuiDaresSlider-info',
                '.MuiDaresSlider-infoItem',
            ],
            selector: 'div#drop-all-dares .dare-card',
            content: (props) => {
                const [, setIsOnboarding] = useOnboardingQueryParam();
                const onSkip = () => {
                    setIsOnboarding(undefined);
                    props.setIsOpen(false);
                };
                return (<OnboardingStep disableNext>
					<div className="flex flex-col gap-2">
						<div className="text-black">
							<p className="text-black font-medium text-lg">Accept a Dare</p>
							<p className="text-black opacity-60">A Dare is a game challenge created by publishers—accept it to earn exclusive
								rewards
							</p>
						</div>
						<OnboardingPrimaryButton onClick={onSkip}>
							Skip
						</OnboardingPrimaryButton>
					</div>
				</OnboardingStep>);
            },
        },
    ];
};
export const DROP_ONBOARDING_INTERACTED_STEPS = (drop) => [
    ...DROP_ONBOARDING_INITIAL_STEPS(drop),
    {
        resizeObservables: [
            '.MuiDaresSlider-info',
            '.MuiDaresSlider-infoItem',
        ],
        disableActions: true,
        selector: 'div#drop-all-dares .dare-card',
        content: (props) => {
            const [, setIsOnboarding] = useOnboardingQueryParam();
            const onSkip = () => {
                setIsOnboarding(undefined);
                props.setIsOpen(false);
            };
            return (<OnboardingStep disableArrows>
					<div className="flex flex-col gap-2">
						<div className="text-black">
							<p className="text-black font-medium text-lg">Deliver</p>
							<p className="text-black opacity-60">
								Once you Accepted Dare, it is a moment to submit it.
							</p>
							<p className="text-black font-bold">Tip: Hover card to deliver.</p>
						</div>
						<OnboardingPrimaryButton onClick={onSkip}>
							Skip
						</OnboardingPrimaryButton>
					</div>
				</OnboardingStep>);
        },
    },
];
